module.exports = __webpack_public_path__ + "media/old_images/icon-stop@2x-d093af92.png";